<template>
  <!-- `size="small"`, o mesmo dos botões do HeaderAction: sem tamanho, o grupo estica a altura dos
       botões e a largura dos de ícone não acompanha — sobrava espaço em branco na célula e o ícone
       saía do centro (achado no teste). -->
  <v-btn-group size="small" divided border rounded="lg" class="action-group">
    <slot/>
  </v-btn-group>
</template>

<script lang="ts">
import {Component, Vue, toNative} from 'vue-facing-decorator'

/**
 * As ações sobre um assunto num bloco só: o `v-btn-group` do Vuetify, com moldura e divisórias — o
 * padrão do app para um conjunto de ações (pedido do usuário), em vez de botões soltos que só
 * pareciam agrupados.
 *
 * Um componente porque o bloco aparece em mais de um lugar — o cabeçalho de toda tela (`PageHeader`)
 * e o cartão de cada propriedade no design —, e o desenho dele, escrito em cada um, divergiria.
 *
 * Os botões entram direto, sem embrulho: dentro de um `span` ou `div` eles ganhariam o vão de quem
 * os embrulha. Os de cabeçalho são `HeaderAction`, que já é `text` e encolhe para ícone no telefone.
 */
@Component({name: 'ontos-action-group'})
class ActionGroup extends Vue {
}

export default toNative(ActionGroup)
</script>

<style scoped>
/* O bloco cujos botões o nível de quem olha escondeu todos (`v-if`): sem isto sobrava a moldura
   vazia. O slot conta como preenchido mesmo assim — o template existe —, e só o que ele desenhou
   diz se há botão. */
.action-group:not(:has(.v-btn)) {
  display: none;
}
</style>
